<template>
  <v-chart
    :option="option"
    :theme="theme"
    :loading="loading"
    :autoresize="true"
    class="chart-container"
    @zr:click="handleZrClick"
    @finished="handleFinished"
  />
</template>
  
  <script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart, PieChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import VChart from 'vue-echarts'

// 按需注册组件
use([CanvasRenderer, BarChart, LineChart, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent])

export default {
  name: 'BaseChart',
  components: {
    VChart
  },
  props: {
    option: {
      type: Object,
      required: true
    },
    theme: {
      type: [String, Object],
      default: 'default'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.initResizeListener()
  },
  beforeDestroy() {
    this.removeResizeListener()
  },
  methods: {
    // 初始化自适应监听
    initResizeListener() {
      this.resizeHandler = () => {
        this.$nextTick(() => {
          this.$refs.chart?.resize()
        })
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    // 移除监听
    removeResizeListener() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }
    },
    // 暴露给父组件的手动resize方法
    manualResize() {
      this.$refs.chart?.resize()
    },
    handleZrClick(event) {
      this.$emit('chart-click', event)
    },
    handleFinished() {
      this.$emit('chart-ready')
    }
  }
}
</script>
  
  <style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  min-height: 100px; /* 可根据需求调整最小高度 */
}
</style>